import { render } from "./static-content-attachment.vue?vue&type=template&id=769b613a"
import script from "./static-content-attachment.vue?vue&type=script&lang=js"
export * from "./static-content-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__